<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>
</ng-container>

<!------------------------------

    Table wrapper

------------------------------->
<sb-table-wrapper-new
  headline="BackgroundWorker"
  [itemsData]="backgroundWorker"
  [hidePagination]="true"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'item'">

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        Executing
      </th>
      <th>
        State
      </th>
      <th>
        loop
      </th>
      <th>
        LastStart
      </th>
      <th>
        LastEnd
      </th>
      <th>
        LastFail
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

     Table Body

------------------------------->
  <ng-template #tbody let-worker>
    <tr>
      <td>
        {{ worker?.name }}
      </td>
      <td>
        {{ worker?.executing }}
      </td>
      <td>
        {{ worker?.state }}
      </td>
      <td>
        {{ worker?.loop }}
      </td>
      <td>
        {{ worker?.lastStart | date: 'dd.MM.yy HH:mm:ss' }}
      </td>
      <td>
        {{ worker?.lastEnd | date: 'dd.MM.yy HH:mm:ss' }}
      </td>
      <td>
        <div *ngIf="worker.lastFail" title="{{worker.lastFailStack}}">
          <div>
            {{ worker?.lastFail | date: 'dd.MM.yy HH:mm:ss' }}
          </div>
          <div>
            {{ worker?.lastFailMessage }}
          </div>
        </div>
      </td>
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="worker.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(worker, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->
  <!-- No card element -->

</sb-table-wrapper-new>
